export default __webpack_public_path__ + "static/media/loginPic.ff850f49.svg";